import styled, { css } from 'styled-components/macro';
import { lowHeightScreens, mediumScreens, smallScreens } from '../common/fontElements';
import { popupContentText } from '../common/colorConstants';
import * as colors from '../common/colorConstants';
import * as breakpoints from '../common/mediaQueries';

export const ContentWrapper = styled.div`
  padding: 16px;
`;

export const PopupContent = styled.div`
  color: ${popupContentText};
  width: ${(props) => props.width || '233px'} !important;
  word-wrap: break-word;

  & grammarly-button {
    display: flex;
  }
`;

export const PopupTextBlock = styled.div`
  margin: 0px 20px 12px;
  font-family: 'Roboto', sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 11px;
  line-height: 16px;
  color: ${colors.darkGray1};
  white-space: pre-line;
`;

export const PopupImage = styled.img`
  height: 26px;

  @media screen and (max-width: ${mediumScreens}) {
    height: 25px;
  }

  @media screen and (max-height: ${lowHeightScreens}), screen and (max-width: ${smallScreens}) {
    height: 22px;
  }
`;

export const ParagraphElement = styled.p`
  margin: 0;
  padding: 0;
`;

export const Subtext = styled(ParagraphElement)`
  font-weight: 400;
`;

export const Header = styled(ParagraphElement)`
  font-family: 'Roboto', sans-serif;
  line-height: 18px;
  font-weight: 500;
  font-size: 14px;
  color: ${colors.black4};
  margin: 12px 20px 9px;

  @media screen and (max-height: ${lowHeightScreens}), screen and (max-width: ${smallScreens}) {
    font-size: 13px;
  }
`;

export const PopupTextArea = styled.textarea`
  width: 100%;
  border-radius: 4px;
  border: 1px solid ${(props) => (props.error ? colors.red3 : colors.lightGray21)};
  font-size: 11px;
  font-weight: 400;
  padding: 7px;
  resize: none;
  box-sizing: border-box;

  &:focus {
    outline: none;
  }

  &::placeholder {
    color: ${colors.lightGray2};
  }

  @media screen and (max-width: ${mediumScreens}) {
    font-size: 11px;
  }

  @media screen and (max-height: ${lowHeightScreens}), screen and (max-width: ${smallScreens}) {
    font-size: 10px;
  }
`;

export const ErrorMessage = styled.div`
  color: ${colors.red3};
  font-size: 10px;
  display: ${(props) => (props.error ? 'inline-flex' : 'none')};
  justify-items: center;
  align-items: center;

  & img {
    width: 10px !important;
    height: 10px !important;
    margin-right: 2px;
  }
`;

export const popupButtonStyles = css`
  width: 50%;
  margin: 0;
  padding: 0;
  line-height: 1.1em;
  font-size: 12px;
  height: 3.5em;
  border: none;
  text-align: center;
  font-weight: 400;
  outline: none;
  text-decoration: none;
  cursor: ${(props) => (props.locked || props.disabled ? 'default' : 'pointer')};
  border-radius: 0px;
  transition: 0.3s;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  &:hover {
    background-color: ${
      // eslint-disable-next-line
      (props) => (props.disabled ? (props.locked ? colors.lightGray34 : colors.disabledBlue) : colors.lightGray34)
    };
    color: ${colors.white};
  }
`;

export const popupButtonDismissStyles = css`
  ${popupButtonStyles};
  background-color: ${colors.lightGray6};
  color: ${colors.darkGray1};
  transition: 0.3s;
`;
export const DismissButton = styled.button`
  ${popupButtonDismissStyles};
`;

export const popupButtonConfirmStyles = css`
  ${popupButtonStyles};
  opacity: ${(props) => (props.disabled && !props.locked ? 0.3 : 1)};
  background-color: ${
    // eslint-disable-next-line
    (props) => (props.disabled ? (props.locked ? colors.lightGray34 : colors.blue1) : colors.blue1)
  };
  color: ${colors.white};
  transition: 0.3s;
`;

export const ConfirmButton = styled.button`
  ${popupButtonConfirmStyles};
`;

export const ProgressSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const ProgressBar = styled.div`
  width: 99px;
  height: 8px;
  border-radius: 4px;
  background-color: ${colors.lightGray13};
  overflow: hidden;
`;

export const Bar = styled.div`
  background-color: ${colors.green1};
  transition: 1s;
  width: ${(props) => props.width}%;
  height: 8px;
  border-radius: 4px 0px 0px 4px;
`;

export const ProgressText = styled.div`
  color: ${colors.black4};
  font-size: 11px;
  margin-bottom: 15px;
`;

// new standardized buttons with clear names

const buttonHeight = '80px';

export const HalfBlueButton = styled.button`
  ${popupButtonConfirmStyles};
  height: ${buttonHeight};
`;

export const HalfGrayButton = styled.button`
  ${popupButtonDismissStyles};
  height: ${buttonHeight};
`;

export const FullBlueButton = styled.button`
  ${popupButtonConfirmStyles};
  width: 100%;
  height: ${buttonHeight};
`;

export const FullGrayButton = styled.button`
  ${popupButtonDismissStyles};
  width: 100%;
  height: ${buttonHeight};
`;

export const PopupWrapper = styled.div`
  background: ${colors.white};
  position: relative;
  width: 460px;
  padding: 65px 50px 50px;
`;

export const ConfirmationPopupWrapper = styled(PopupWrapper)`
  @media screen and (min-width: ${breakpoints.minLaptop}) {
    width: 460px;
    padding: 80px 65px 50px;
  }
`;

export const PopupTitle = styled.div`
  font-size: 20px;
  line-height: 22px;
  color: ${colors.lightBlack};
  font-weight: 500;
`;

export const PopupTitleCentered = styled(PopupTitle)`
  text-align: center;
`;

export const PopupSubtitleCentered = styled.div`
  font-size: 13px;
  line-height: 17px;
  text-align: center;
  color: ${colors.darkGray1};
  margin: 15px 0 15px 0;
`;

export const NewPopupTitle = styled(PopupTitle)`
  text-align: left;
  margin-top: -25px;
  font-weight: bold !important;
`;

export const NewPopupConfirmation = styled(PopupTitle)`
  text-align: left;
  font-weight: bold !important;
`;

export const NewPopupSubtitle = styled.div`
  font-size: 13px;
  line-height: 17px;
  text-align: left;
  color: ${colors.darkGray1};
  margin: 15px 0 15px 0;
`;

export const ConfirmationNewPopupTitle = styled(NewPopupTitle)`
  text-align: center;
`;

export const ConfirmationNewPopupSubtitle = styled(NewPopupSubtitle)`
  text-align: center;
  margin: 25px 0 50px 0;
`;

export const FieldLabel = styled.p`
  color: ${colors.darkGray12};
  margin: 25px 0px 15px;
  font-size: 14px;
  text-align: left;
  font-weight: 500;

  &:first-child {
    margin: 0px 0px 15px 0px;
  }
`;

export const ValidationMessage = styled.p`
  color: ${colors.red3};
  margin: 25px 0px 15px;
  font-size: 14px;
  font-weight: 500;
  text-align: center;
`;

export const StrongNewPopupSubtitle = styled.div`
  font-size: 13px;
  line-height: 17px;
  color: ${colors.lightBlack};
  font-weight: bold !important;
`;

export const PopupSubtitle = styled.div`
  font-size: 14px;
  line-height: 18px;
  color: ${colors.lightGray2};
`;

export const Checkbox = styled.input`
  margin: 0 15px 0 5px !important;
  border-radius: 0px;
  stroke: black !important;
  stroke-width: 2px;
  &:hover {
    cursor: pointer;
  }
`;

export const CheckBoxWrapper = styled.div`
  align-items: center;
  display: flex;
  margin-top: 10px;

  & p {
    margin-bottom: 0 !important;
  }
`;

export const PopupButton = styled.button`
  margin: 0;
  outline: 0;
  font-size: 13px;
  background-color: ${colors.blue1};
  color: ${colors.white};
  border: none;
  cursor: pointer;
  height: 40px;
  border-radius: 3px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const PopupButtonFullWidth = styled(PopupButton)`
  width: 100%;
`;
